/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
import '../common/vpos/checkout';
import '../common/signature';
import '../common/tipping';
import '../common/payment_sounds';
import '../common/security';
import '../rst/common/appearance';
import '../rst/common/text_customer';
import '../addons/loyalty';
import '../addons/text_message_marketing';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "fnbkiosk": {
                            "nested": {
                              "FNBKioskSettings": {
                                "fields": {
                                  "checkout": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.common.vpos.Checkout",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "signature": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.common.Signature",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "tipping": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.common.Tipping",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "paymentSounds": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.common.PaymentSounds",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "security": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.common.Security",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "addonsSettings": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.fnbkiosk.AddonsSettings",
                                    "id": 6,
                                    "rule": "optional"
                                  },
                                  "appearance": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.rst.common.Appearance",
                                    "id": 7,
                                    "rule": "optional"
                                  },
                                  "textCustomer": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.rst.common.TextCustomer",
                                    "id": 8,
                                    "rule": "optional"
                                  },
                                  "fnbKiosk": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.fnbkiosk.FNBKiosk",
                                    "id": 9,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "AddonsSettings": {
                                "fields": {
                                  "loyalty": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.addons.Loyalty",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "textMessageMarketing": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.addons.TextMessageMarketing",
                                    "id": 2,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "FNBKiosk": {
                                "fields": {
                                  "allowGiftCards": {
                                    "type": "bool",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "diningOptions": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.fnbkiosk.FNBKiosk.FNBKioskDiningOption",
                                    "id": 2,
                                    "rule": "repeated"
                                  }
                                },
                                "nested": {
                                  "FNBKioskDiningOption": {
                                    "fields": {
                                      "diningOptionId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "kioskOrdinal": {
                                        "type": "int32",
                                        "id": 2,
                                        "rule": "optional"
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.fnbkiosk?.nested?.FNBKioskSettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.fnbkiosk?.nested?.AddonsSettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.fnbkiosk?.nested?.FNBKiosk && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.fnbkiosk?.nested?.FNBKiosk?.nested?.FNBKioskDiningOption) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE FNBKioskSettings @ squareup/devicesettings/profiles/v2/model/settings/fnbkiosk/fnb_kiosk_settings.proto at 23:1
 */
export const FNBKioskSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.fnbkiosk.FNBKioskSettings');
fixType(FNBKioskSettings);
Builder.createAndAttachToType(FNBKioskSettings);
/**
 * SOURCE AddonsSettings @ squareup/devicesettings/profiles/v2/model/settings/fnbkiosk/fnb_kiosk_settings.proto at 41:1
 */
export const AddonsSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.fnbkiosk.AddonsSettings');
fixType(AddonsSettings);
Builder.createAndAttachToType(AddonsSettings);
/**
 * SOURCE FNBKiosk @ squareup/devicesettings/profiles/v2/model/settings/fnbkiosk/fnb_kiosk_settings.proto at 48:1
 */
export const FNBKiosk = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.fnbkiosk.FNBKiosk');
fixType(FNBKiosk);
Builder.createAndAttachToType(FNBKiosk);
/**
 * SOURCE FNBKioskDiningOption @ squareup/devicesettings/profiles/v2/model/settings/fnbkiosk/fnb_kiosk_settings.proto at 53:3
 */
FNBKiosk.FNBKioskDiningOption = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.fnbkiosk.FNBKiosk.FNBKioskDiningOption');
fixType(FNBKiosk.FNBKioskDiningOption);
Builder.createAndAttachToType(FNBKiosk.FNBKioskDiningOption);